import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { gsap } from 'gsap';
import { md, lg, xl, wide, xwide } from '../common';

function ensureVideoSource(videoEl) {
  if (!videoEl) return;

  const src = (videoEl.dataset.src || '').trim();
  if (!src || videoEl.getAttribute('src')) return;

  videoEl.src = src;
  videoEl.load();
}

async function playVideoSafe(videoEl) {
  if (!videoEl) return;

  try {
    await videoEl.play();
  } catch {
    // Ignore autoplay restrictions.
  }
}

function syncActiveSlideVideos(swiper) {
  if (!swiper) return;

  const activeIndex = swiper.activeIndex || 0;
  const slidesPerView = Number(swiper.params.slidesPerView) || 1;
  const lastVisibleIndex = activeIndex + Math.ceil(slidesPerView) - 1;

  swiper.slides.forEach((slide, index) => {
    const videos = slide.querySelectorAll('video[data-src]');
    if (!videos.length) return;

    const isVisible = index >= activeIndex && index <= lastVisibleIndex;
    videos.forEach((videoEl) => {
      if (isVisible) {
        ensureVideoSource(videoEl);
        void playVideoSafe(videoEl);
        return;
      }

      videoEl.pause();
    });
  });
}

export function initBlockCaseStudy(parent) {
  if (!parent) return;

  const swiper = parent.querySelector('.swiper');
  if (swiper) {
    const nextEl = parent.querySelector('.swiper-button-next');
    const prevEl = parent.querySelector('.swiper-button-prev');
    const paginationEl = parent.querySelector('.swiper-pagination');

    const swiperInstance = new Swiper(swiper, {
      modules: [Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        [md]: { slidesPerView: 2, spaceBetween: 20 },
        [lg]: { slidesPerView: 2, spaceBetween: 20 },
        [wide]: { slidesPerView: 2, spaceBetween: 24 },
        [xwide]: { slidesPerView: 2, spaceBetween: 32 },
      },
    });

    syncActiveSlideVideos(swiperInstance);
    swiperInstance.on('slideChangeTransitionEnd', () => {
      syncActiveSlideVideos(swiperInstance);
    });
    swiperInstance.on('breakpoint', () => {
      syncActiveSlideVideos(swiperInstance);
    });
  }

  const cards = parent.querySelectorAll('.case-card');
  cards.forEach((card, index) => {
    card.addEventListener('click', () => {
      card.classList.toggle('is-active');
    });

    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initAllCaseStudyBlocks() {
  const blocks = document.querySelectorAll('.js-block-case-study');
  blocks.forEach((block) => initBlockCaseStudy(block));
}
